import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthUser, Utente } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { StorageService } from '../../../services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-utenti-backoffice',
  templateUrl: './utenti-backoffice.component.html',
  styleUrl: './utenti-backoffice.component.css'
})
export class UtentiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private storageService: StorageService, private confirmationService: ConfirmationService, private router: Router) { }

  @ViewChild("deleteUtente") deleteUtente!: ConfirmPopup;

  utenti: Utente[] = []

  user?: AuthUser | null;

  loading: boolean = false;

  ngOnInit(): void {

    this.loading = true;

    this.user = this.storageService.getUser();

    this.apiService.setUtenti();
    this.apiService.utentiChanged.subscribe({
      next: (data) => {
        this.utenti = [...data.filter(utente => utente.editable || this.user?.user == 'root')];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteUtente(event: Event, utente: Utente) {

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare l'utente? ${this.user?.id == utente?.id ? "Stai eliminando l'utente con cui sei loggato!" : ""}`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteUtente(utente.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {

            if (this.user?.id == utente?.id) {
              this.storageService.clearStorage()
              this.router.navigate(['/backoffice/login']);
            } else {
              this.router.navigate(['/backoffice/utenti']);
            }

            this.confirmationService.close()
            this.apiService.setUtenti()
            this.apiService.message("success", "Eliminazione", "L'utente è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteUtente() {
    this.deleteUtente.accept();
  }

  onAnnullaDeleteUtente() {
    this.deleteUtente.reject();
  }

}
